class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this),
        this.debouncedOnSubmit = debounce(e2=>{
            this.onSubmitHandler(e2)
        }
        , 500),
        this.querySelector("form").addEventListener("input", e2=>{
            FacetFiltersForm.loading.start(),
            this.debouncedOnSubmit(e2)
        }
        )
    }
    static setListeners() {
        const e = e2=>{
            const t = e2.state ? e2.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1)
        }
        ;
        window.addEventListener("popstate", e)
    }
    static renderPage(e, t, r=!0) {
        FacetFiltersForm.searchParamsPrev = e,
        FacetFiltersForm.getSections().forEach(r2=>{
            const s2 = `${window.location.pathname}?section_id=${r2.section}&${e}`
              , a = e2=>e2.url === s2;
            FacetFiltersForm.filterData.some(a) ? FacetFiltersForm.renderSectionFromCache(a, t) : FacetFiltersForm.renderSectionFromFetch(s2, t)
        }
        ),
        window.scroll({
            top: FacetFiltersForm.section.offsetTop - 100,
            left: 0,
            behavior: "smooth"
        }),
        FacetFiltersForm.loading.finish(),
        r && FacetFiltersForm.updateURLHash(e)

    }
    static renderSectionFromFetch(e, t) {
        fetch(e).then(e2=>e2.text()).then(r=>{
            const s = r;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
                html: s,
                url: e
            }],
            FacetFiltersForm.renderFilters(s, t),
            FacetFiltersForm.renderElements(s, "[data-product-container]", FacetFiltersForm.selectors.productGrid),
            FacetFiltersForm.renderElements(s, "[data-facet-form]", FacetFiltersForm.selectors.filtersForm),
            FacetFiltersForm.renderProductCount(s)

            // Check samples page buttons
            let recoCart = new CartDrawer; 
            recoCart.checkSamples();
            if(typeof window.addQuickLinks === 'function') window.addQuickLinks();
        }
        )
    }
    static renderSectionFromCache(e, t) {
        const r = FacetFiltersForm.filterData.find(e).html;
        FacetFiltersForm.renderFilters(r, t),
        FacetFiltersForm.renderElements(r, "[data-product-container]", FacetFiltersForm.selectors.productGrid),
        FacetFiltersForm.renderElements(r, "[data-facet-form]", FacetFiltersForm.selectors.filtersForm),
        FacetFiltersForm.renderProductCount(r)

        // Check samples page buttons
        let recoCart = new CartDrawer; 
        recoCart.checkSamples();
        if(typeof window.addQuickLinks === 'function') window.addQuickLinks();
    }
    static renderElements(e, t, r) {
        const s = document.querySelector(t);
        s.innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML,
        FacetFiltersForm.loading = new window.FoxTheme.AnimateLoading(document.body,{
            overlay: document.querySelector(r)
        }),
        __reInitTooltip(s)
    }
    static renderProductCount(e) {
        const t = new DOMParser().parseFromString(e, "text/html").querySelector(FacetFiltersForm.selectors.productCount).innerHTML
          , r = document.querySelector(FacetFiltersForm.selectors.productCount);
        r.innerHTML = t
    }
    static renderFilters(e, t) {
        const r = new DOMParser().parseFromString(e, "text/html")
          , s = r.querySelectorAll("#FacetFiltersForm .js-filter")
          , a = e2=>{
            const r2 = t ? t.target.closest(".js-filter") : void 0;
            return r2 ? e2.dataset.index === r2.dataset.index : !1
        }
        ;
        Array.from(s).filter(e2=>!a(e2)).forEach(e2=>{
            const t2 = document.querySelector(`.f-facets__block[data-index="${e2.dataset.index}"]`);
            if (!t2)
                return;
            t2.textContent = "";
            const r2 = e2.querySelector("collapsible-tab") || e2.querySelector("#Mobile-SortBy-Block");
            r2 && t2.appendChild(r2)
        }
        ),
        FacetFiltersForm.renderActiveFacets(r)
    }
    static renderActiveFacets(e) {
        [".active-facets"].forEach(t2=>{
            const r = e.querySelector(t2);
            r && (document.querySelector(t2).innerHTML = r.innerHTML)
        }
        )
    }
    static updateURLHash(e) {
        history.pushState({
            searchParams: e
        }, "", `${window.location.pathname}${e && "?".concat(e)}`)
    }
    static getSections() {
        return [{
            section: FacetFiltersForm.sectionId
        }]
    }
    createSearchParams(e) {
        const t = new FormData(e);
        return e.id === "FacetFiltersForm" && !FoxThemeSettings.isMobile && t.delete("sort_by"),
        new URLSearchParams(t).toString()
    }
    onSubmitForm(e, t) {
        FacetFiltersForm.renderPage(e, t)
    }
    onSubmitHandler(e) {
        const t = document.querySelectorAll("facet-filters-form form");
        if (FoxThemeSettings.isMobile) {
            const t2 = this.createSearchParams(e.target.closest("form"));
            this.onSubmitForm(t2, e)
        } else {
            const r = [];
            t.forEach(e2=>{
                r.push(this.createSearchParams(e2))
            }
            ),
            this.onSubmitForm(r.join("&"), e)
        }
    }
    onActiveFilterClick(e) {
        e.preventDefault();
        const t = e.currentTarget.href.indexOf("?") === -1 ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(t)
    }
}
FacetFiltersForm.selectors = {
    container: ".f-facets__container",
    productGrid: "[data-products-grid]",
    productCount: "[data-product-count]",
    filtersForm: "[data-facet-form]",
    facetWrapper: "[data-facets-wrapper]",
    facetBlock: ".f-facets__block"
},
FacetFiltersForm.section = document.querySelector("#ProductGridContainer"),
FacetFiltersForm.sectionId = FacetFiltersForm.section && FacetFiltersForm.section.dataset.sectionId,
FacetFiltersForm.domNodes = queryDomNodes(FacetFiltersForm.selectors, FacetFiltersForm.section),
FacetFiltersForm.loading = new window.FoxTheme.AnimateLoading(document.body,{
    overlay: document.querySelector(FacetFiltersForm.selectors.productGrid)
}),
FacetFiltersForm.filterData = [],
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1),
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1),
customElements.define("facet-filters-form", FacetFiltersForm),
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super(),
        this.selectors = {
            inputs: ['input[type="number"]'],
            ranges: ['input[type="range"]'],
            minRange: '[data-type="min-range"]',
            maxRange: '[data-type="max-range"]',
            minInput: '[data-type="min-input"]',
            maxInput: '[data-type="max-input"]'
        },
        this.domNodes = queryDomNodes(this.selectors, this),
        this.priceGap = parseInt(this.dataset.priceGap),
        this.priceMax = parseInt(this.dataset.priceMax),
        this.domNodes.inputs.forEach(e=>e.addEventListener("change", this.onInputChange.bind(this))),
        this.domNodes.ranges.forEach(e=>e.addEventListener("input", this.onSliderChange.bind(this))),
        this.setMinAndMaxValues()
    }
    onSliderChange(e) {
        const t = e.currentTarget
          , r = t.dataset.type
          , s = Number(t.value)
          , {minInput: a, maxInput: o, minRange: i, maxRange: n} = this.domNodes;
        r === "min-range" && (n.value - t.value >= this.priceGap ? a.value = t.value : t.value = n.value - this.priceGap),
        r === "max-range" && (t.value - i.value >= this.priceGap ? o.value = t.value : t.value = Number(i.value) + Number(this.priceGap)),
        this.style.setProperty("--price-min", 100 * i.value / this.priceMax + "%"),
        this.style.setProperty("--price-max", 100 * n.value / this.priceMax + "%")
    }
    onInputChange(e) {
        this.adjustToValidValues(e.currentTarget),
        this.setMinAndMaxValues()
    }
    setMinAndMaxValues() {
        const {minInput: e, maxInput: t} = this.domNodes;
        t.value && e.setAttribute("max", Number(t.value) - this.priceGap),
        e.value && t.setAttribute("min", Number(e.value) + this.priceGap),
        e.value === "" && t.setAttribute("min", 0),
        t.value === "" && e.setAttribute("max", t.getAttribute("max"))
    }
    adjustToValidValues(e) {
        const t = Number(e.value)
          , r = Number(e.getAttribute("min"))
          , s = Number(e.getAttribute("max"));
        t < r && (e.value = r),
        t > s && (e.value = s)
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("a").addEventListener("click", e=>{
            e.preventDefault(),
            (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e)
        }
        )
    }
}
customElements.define("facet-remove", FacetRemove);
class ApplyButton extends HTMLElement {
    constructor() {
        super();
        const e = this.closest("drawer-component");
        this.querySelector("button").addEventListener("click", t=>{
            t.preventDefault(),
            e && e.closeDrawer(!1)
        }
        )
    }
}
customElements.define("facet-apply", ApplyButton);
class ShowMoreButton extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("button").addEventListener("click", e2=>{
            this.expandShowMore(e2);
            const t = e2.target.closest(".parent-display") && e2.target.closest(".parent-display").querySelector(".show-more-item");
            t && !t.classList.contains("hidden") && t.querySelector("input").focus()
        }
        )
    }
    expandShowMore(e) {
        const t = e.target.closest('[id^="Show-More-"]').closest(".f-facets__block-content");
        this.querySelectorAll(".label-text").forEach(e2=>e2.classList.toggle("hidden")),
        t.querySelectorAll(".show-more-item").forEach(e2=>e2.classList.toggle("hidden"))
    }
}
customElements.define("show-more-button", ShowMoreButton);

